export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECTDETAILS = "GET_PROJECTDETAILS";
export const RESET_PROJECT_DETAILS = "RESET_PROJECT_DETAILS";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_ABOUT = "GET_ABOUT";
export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";
export const GET_TESTIMONIALS_REQUEST = "GET_TESTIMONIALS_REQUEST";
export const GET_TESTIMONIALS_SUCCESS = "GET_TESTIMONIALS_SUCCESS";
export const GET_TESTIMONIALS_FAILURE = "GET_TESTIMONIALS_FAILURE";
